import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { projects } from '../data';

function ProjectCard({ project }) {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  function handleClick() {
    if (project.link) {
      window.open(project.link, '_blank', 'noreferrer');
    }
  }

  return (
    <div
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'block',
        background: hovered ? '#eeecea' : '#f4f3f0',
        padding: '2rem',
        border: '0.5px solid rgba(100,98,92,0.15)',
        textDecoration: 'none',
        transition: 'background 0.3s',
        cursor: project.link ? 'pointer' : 'default',
      }}
    >
      <div style={{
        fontSize: '10px', letterSpacing: '0.18em',
        color: '#9b9991', marginBottom: '1.5rem',
      }}>
        {project.num}
      </div>

      <div style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: '22px', fontWeight: 300,
        color: '#2e2d2a', lineHeight: 1.2, marginBottom: '0.75rem',
      }}>
        {project.title}
      </div>

      <p style={{
        fontSize: '12px', color: '#6b6963',
        lineHeight: 1.7, marginBottom: '1.5rem',
      }}>
        {project.description}
      </p>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
        {project.tags.map((tag) => (
          <span key={tag} style={{
            fontSize: '10px', letterSpacing: '0.1em',
            textTransform: 'uppercase', color: '#9b9991',
            border: '0.5px solid #cccac3',
            padding: '3px 10px', borderRadius: '2px',
          }}>
            {tag}
          </span>
        ))}
      </div>

      {project.docsLink && (
        <button
          onClick={(e) => { e.stopPropagation(); navigate(project.docsLink); }}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '6px',
            marginTop: '1.25rem',
            fontSize: '11px', letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: '#3d6e78',
            background: 'none', border: 'none',
            borderBottom: '0.5px solid rgba(61,110,120,0.3)',
            paddingBottom: '1px', paddingLeft: 0, paddingRight: 0,
            cursor: 'pointer',
            fontFamily: "'DM Mono', monospace",
          }}
          onMouseEnter={(e) => e.currentTarget.style.borderBottomColor = '#3d6e78'}
          onMouseLeave={(e) => e.currentTarget.style.borderBottomColor = 'rgba(61,110,120,0.3)'}
        >
          Documentation &#x2197;
        </button>
      )}
    </div>
  );
}

export default function Projects() {
  return (
    <section id="projects" style={{
      padding: '6rem 2.5rem',
      maxWidth: '900px', margin: '0 auto',
      fontFamily: "'DM Mono', monospace",
    }}>
      <div style={{
        fontSize: '10px', letterSpacing: '0.22em',
        textTransform: 'uppercase', color: '#9b9991',
        marginBottom: '3rem',
        display: 'flex', alignItems: 'center', gap: '1rem',
      }}>
        Projects
        <span style={{ flex: 1, height: '0.5px', background: 'rgba(100,98,92,0.15)', maxWidth: '60px' }} />
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
        gap: '0',
        border: '0.5px solid rgba(100,98,92,0.15)',
        borderRadius: '4px',
        overflow: 'hidden',
      }}>
        {projects.map((p) => (
          <ProjectCard key={p.num} project={p} />
        ))}
      </div>
    </section>
  );
}
